import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Token expiré ou invalide — re-déclencher le login PKCE
        authService.login();
      }
      if (error.status === 403) {
        // Log discret — le composant appelant gère l'affichage du message
        console.warn(
          `Accès refusé [${error.error?.['code'] ?? '403'}]: ${error.error?.['message'] ?? ''}`
        );
      }
      return throwError(() => error);
    })
  );
};
